import { get, post } from '../../util/api';

// Fetch all listings with pending edits
export const fetchPendingEdits = () => {
  return get('/api/moderation/pending-edits');
};

// Approve pending edits for a listing
export const approveEdit = (listingId, adminComment) => {
  return post('/api/moderation/approve-edit', { listingId, adminComment });
};

// Reject pending edits for a listing
export const rejectEdit = (listingId, rejectionReason) => {
  return post('/api/moderation/reject-edit', { listingId, rejectionReason });
};
